<template>
  <div class="add-member-modal addgzhxx">
    <el-dialog :visible.sync="addModalVisible"
               width="1280px"
               :before-close="handleClose"
               :close-on-click-modal="closeonclickmodal"
               v-el-drag-dialog>
      <div slot="title"
           class="member-modal-title">
        <span class="modal-title-span">{{addModalTitle}}</span>
      </div>
      <div class="member-modal-content">
        <div class="third-rea">
          <div class="third-btn">
            <div class="btn-left">检索条件</div>
            <div class="btn-right">
              <el-button class="btn-two"
                         type="primary"
                         @click="searchInput">查询</el-button>
              <el-button class="btn-two"
                         type="default"
                         @click="resetInput">重置</el-button>
              <!-- <span class="btn-shu"></span>
							<el-button class="btn-four" type="default" icon="el-icon-search" @click="hignSearch">高级检索</el-button> -->
            </div>
          </div>
          <div class="third-search"
               style="padding-bottom: 0;">
            <el-form :inline="true"
                     :model="addData"
                     label-width="76px"
                     @keyup.native.enter="searchInput">
              <div class="search-row">
                <div class="row-item member-search-item"
                     v-for="(value, key) in addData"
                     :key="key">
                  <el-form-item :label="addItem[key].label">
                    <template v-if="addItem[key].type === 'input'">
                      <el-input :maxlength="30"
                                class="item-input"
                                v-model="addData[key]"
                                :placeholder="addItem[key].placeholder"></el-input>
                    </template>
                    <template v-if="addItem[key].type === 'select'">
                      <key-value-select :isNeedAll="addItem[key].isNeedAll"
                                        className="item-input"
                                        v-model="addData[key]"
                                        :placeholder="addItem[key].placeholder"
                                        :dictUrl="addItem[key].url"
                                        :openSearch="addItem[key].canSearch"
                                        :resetSearch="resetSearch"></key-value-select>
                    </template>
                    <template v-if="addItem[key].type === 'date'">
                      <el-date-picker class="item-input"
                                      v-model="addData[key]"
                                      type="datetime"
                                      format="yyyy-MM-dd HH:mm"
                                      value-format="yyyy-MM-dd HH:mm"
                                      align="right"
                                      :placeholder="addItem[key].placeholder">
                      </el-date-picker>
                    </template>
                    <template v-if="addItem[key].type === 'cascader'">
                      <el-cascader class="item-input"
                                   v-model="addData[key]"
                                   :options="addItem[key].options"
                                   :placeholder="addItem[key].placeholder"></el-cascader>
                    </template>
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </div>
        </div>
        <div class="third-one">
          <el-table ref="addMemberTable"
                    class="third-tableThree tableThree-add"
                    :data="tableData"
                    @select="handleSelection"
                    @select-all="selectAllBox"
                    border
                    stripe
                    v-loading="loading">
            <el-table-column type="selection"
                             width="32px"
                             :selectable='selectable'>
            </el-table-column>
            <template v-for="(item, index) in addColumn">
              <el-table-column v-if="item.needKeyValue"
                               min-width="100px"
                               :prop="item.key"
                               :label="item.column"
                               :key="index"
                               :show-overflow-tooltip="true">
                <template v-if="item.needKeyValue == 'mpType'"
                          slot-scope="scope">
                  <span v-if="scope.row[item.key] == 3">服务号</span>
                  <span v-if="scope.row[item.key] == 4">部门号</span>
                  <span v-if="scope.row[item.key] == 5">订阅号</span>
                </template>
                <template v-else
                          slot-scope="scope">
                  <key-value-span :value="scope.row[item.key]"
                                  :dictUrl="item.actionUrl"></key-value-span>
                </template>
              </el-table-column>
              <el-table-column v-else
                               min-width="100px"
                               :prop="item.key"
                               :label="item.column"
                               :key="index"
                               :show-overflow-tooltip="true">
              </el-table-column>
            </template>
          </el-table>
          <div class="third-page add-modal-page">
            <div class="page-left">
              <!-- <el-button class="btn-one" type="primary" @click="selectAll">选中全部</el-button>
							<el-button type="primary" @click="cancelAll">取消全选</el-button> -->
              <span class="left-data">已选中{{selectCount}}条数据</span>
            </div>
            <el-pagination class="page-right"
                           @size-change="addSizeChange"
                           @current-change="addCurrentChange"
                           :current-page="addPage"
                           background
                           :page-sizes="[10, 20, 30, 40]"
                           :page-size="addPageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="stuAddTotal">
            </el-pagination>
          </div>
        </div>
      </div>
      <div slot="footer"
           class="member-modal-footer">
        <el-button class="modal-footer-two"
                   @click="closeModal">取消</el-button>
        <el-button class="modal-footer-two"
                   type="primary"
                   @click="agreeAdd">确定</el-button>
      </div>
    </el-dialog>
    <!-- <hign-modal :hignModalVisible="hignModal" @searchModal="toHignSearch" @cancelModal="closeHign" :hignOneList="addColumn"></hign-modal> -->
  </div>
</template>

<script>

export default {
  name: 'addMemberModal',
  props: {
    addData: {
      type: Object,
    },
    addItem: {
      type: Object
    },
    addColumn: {
      type: Array,
    },
    childrenList: {
      type: Array,
      default: () => { [] }
    },
    addModalVisible: {
      type: Boolean,
      default: false
    },
    addModalTitle: {
      type: String,
      default: '添加人员（不含已有人员）'
    },
    addType: {
      type: String,
      default: '1'
    },
    //是否点击空白处关闭弹窗
    closeonclickmodal: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    addModalVisible (val) {
      // console.log(val)
      // console.log(this.addType)
      if (val) {
        this.resetSearch = false
        this.stuAddRole()
      } else {
        this.resetSearch = true
      }
      // console.log(this.addColumn)
    }
  },
  created () {
  },
  data () {
    return {
      loading: false,
      onlyId: 'id', // 添加人员列表的唯一标识
      addPage: 1, // 页码
      addPageSize: 10, // 条数
      stuAddTotal: 0, // 总数
      tableData: [], // 添加弹窗表格
      selectArr: [], // 排除的选中项/或当前选中项，根据是否全选决定,
      allSelect: false, // 是否全选
      resetSearch: false, // 重置搜索选择项
      hignModal: false, // 高级搜索
      hignSearchRes: '', // 高级检索条件
      selectCount: 0, // 选中多少条
      fixCount: 0, // 不随搜索条件改变的列表总数
    }
  },
  computed: {
    // isdis() {
    //   return true
    // },
  },
  methods: {
    selectable (row) {
      // console.log(row);
      // console.log(this.childrenList);
      for (let i = 0; i < this.childrenList.length; i++) {
        if (row.messageId == this.childrenList[i].id) {
          return false
        }
      }
      return true

    },
    // 重置方法
    resetFormData () {
      // console.log(this.addData)
      this.hignSearchRes = ''
      this.$nextTick(async () => {
        this.addPage = 1
        await this.stuAddRole()
        this.pageChanageSelect()
      })
    },
    // 搜索
    async searchInput () {
      this.hignSearchRes = ''
      this.addPage = 1
      // console.log(this.addData)
      await this.stuAddRole()
      this.pageChanageSelect()
    },
    // 重置
    resetInput () {
      this.$emit('resetAddForm')
    },
    // 选中全部
    selectAllBox (val) {
      // console.log(val.length)
      if (this.allSelect) {
        if (val.length === 0) {
          this.tableData.forEach(element => {
            element.isChecked = false
            console.log(this.selectArr.indexOf(element))
            if (this.selectArr.indexOf(element) === -1) {
              this.selectArr.push(element)
            }
          });
        } else {
          val.forEach(element => {
            element.isChecked = true
            this.selectArr.forEach(elements => {
              if (element[this.onlyId] === elements[this.onlyId]) {
                this.selectArr.splice(this.selectArr.indexOf(elements), 1)
              }
            });
          });
        }
        this.selectCount = this.fixCount - this.selectArr.length
      } else {
        console.log(val);
        if (val.length === 0) {
          if (val.length > 10) {
            val
          }
          this.tableData.forEach(element => {
            element.isChecked = false
            this.selectArr.forEach(elements => {
              if (element[this.onlyId] === elements[this.onlyId]) {
                this.selectArr.splice(this.selectArr.indexOf(elements), 1)
              }
            });
          });
        } else {
          val.forEach(element => {
            element.isChecked = true
            console.log(this.selectArr.indexOf(element))
            this.selectArr.forEach(elements => {
              if (element[this.onlyId] === elements[this.onlyId]) {
                this.selectArr.splice(this.selectArr.indexOf(elements), 1)
              }
            });
            if (this.selectArr.indexOf(element) === -1) {
              this.selectArr.push(element)
            }
          });
        }
        this.selectCount = this.selectArr.length
      }
      console.log(this.selectArr)
    },
    // 选中项
    handleSelection (selection, val) {
      val.isChecked = !val.isChecked
      // console.log(val)
      // console.log(this.tableData)
      if (this.allSelect) {
        if (!val.isChecked && this.selectArr.indexOf(val) === -1) {
          this.selectArr.push(val)
        } else {
          this.selectArr.forEach(element => {
            if (element[this.onlyId] === val[this.onlyId]) {
              this.selectArr.splice(this.selectArr.indexOf(element), 1)
            }
          });
        }
        console.log(this.selectArr)
        this.selectCount = this.fixCount - this.selectArr.length
      } else {
        if (this.selectArr.length >= 10) {
          this.$refs.addMemberTable.toggleRowSelection(val, false)
          this.$message.error('最多选择10条数据')
          return
        }
        if (val.isChecked && this.selectArr.indexOf(val) === -1) {
          this.selectArr.push(val)
        } else {
          this.selectArr.forEach(element => {
            if (element[this.onlyId] === val[this.onlyId]) {
              this.selectArr.splice(this.selectArr.indexOf(element), 1)
            }
          });
        }
        this.selectCount = this.selectArr.length
      }
    },
    // 选中全部
    selectAll () {
      this.tableData.forEach(row => {
        row.isChecked = true
        this.$refs.addMemberTable.toggleRowSelection(row, true)
      });
      this.selectArr = []
      this.selectCount = this.fixCount
      this.allSelect = true
    },
    // 取消选中全部
    cancelAll () {
      this.tableData.forEach(row => {
        row.isChecked = false
        this.$refs.addMemberTable.toggleRowSelection(row, false)
      });
      this.selectCount = 0
      this.selectArr = []
      this.allSelect = false
    },
    // 切换页选中全部
    pageChanageSelect () {
      this.tableData.forEach(row => {
        if (this.allSelect) {
          row.isChecked = true
          this.$refs.addMemberTable.toggleRowSelection(row, true)
          if (this.selectArr.length !== 0) {
            this.selectArr.forEach(element => {
              if (row[this.onlyId] === element[this.onlyId]) {
                row.isChecked = false
                this.$refs.addMemberTable.toggleRowSelection(row, false)
              }
            });
          }
        } else {
          if (this.selectArr.length !== 0) {
            this.selectArr.forEach(element => {
              if (row[this.onlyId] === element[this.onlyId]) {
                row.isChecked = true
                this.$refs.addMemberTable.toggleRowSelection(row, true)
              }
            });
          }
        }
      });
    },
    // 条数变化
    async addSizeChange (val) {
      this.addPage = 1
      this.addPageSize = val
      await this.stuAddRole()
      this.pageChanageSelect()
    },
    // 页码变化
    async addCurrentChange (val) {
      this.addPage = val
      await this.stuAddRole()
      this.pageChanageSelect()
    },
    // 弹窗关闭触发
    handleClose () {
      this.selectCount = 0
      this.allSelect = false
      this.selectArr = []
      this.addPage = 1
      this.$emit('closeAddModal');
    },
    // 确认
    agreeAdd () {
      // console.log(this.allSelect)
      // console.log(this.selectArr)
      // this.$emit('agreeAddMember',this.selectArr)
      if (this.selectCount === 0) {
        this.$message.error('请选择数据')
      } else {
        this.$emit('agreeAddMember', this.selectArr)
      }
    },
    // 取消
    closeModal () {
      this.selectCount = 0
      this.allSelect = false
      this.selectArr = []
      this.addPage = 1
      this.$emit('closeAddModal');
    },
    // 学生-查询添加人员列表
    async stuAddRole () {
      console.log(this.addData)
      this.loading = true
      const stuAddRole = await this.$store.dispatch('themeArticleMpMessageList', {
        "pageIndex": this.addPage,//分页参数
        "pageSize": this.addPageSize,
        "title": this.addData.title, //消息标题
        "mpName": this.addData.mpName, //公众号名称
        "content": this.addData.content,//内容
        "accountSubject": this.addData.accountSubject//账号主体
      })
      this.loading = false
      console.log(stuAddRole)
      if (stuAddRole.data.status === 1000) {
        if (stuAddRole.data.result.data.length !== 0) {
          this.tableData = stuAddRole.data.result.data
          this.tableData.forEach(element => {
            element.isChecked = false
          });
          this.stuAddTotal = stuAddRole.data.result.total
        } else {
          this.tableData = []
          this.stuAddTotal = 0
        }
        this.fixCount = stuAddRole.data.result.fixedCount
      } else {
        this.tableData = []
        this.stuAddTotal = 0
      }
    },
  }
}
</script>

<style lang="scss">
.addgzhxx {
  .el-table__header-wrapper .el-checkbox {
    display: none;
  }
}
.add-member-modal {
  .el-dialog__header {
    border-bottom: 1px solid #d4d4d7;
    padding: 11px 16px;
    .el-dialog__headerbtn {
      top: 11px;
      right: 16px;
    }
    .member-modal-title {
      .modal-title-icon {
        font-size: 12px;
      }
      .modal-title-span {
        font-size: 12px;
        color: #2e4057;
        font-weight: bold;
      }
    }
  }
  .el-dialog__body {
    height: 500px;
    padding: 8px;
    overflow-y: auto;
    .member-modal-content {
      .member-search-item {
        width: 300px !important;
        text-align: right !important;
        padding-bottom: 8px;
      }
      .tableThree-add {
        .el-table__body-wrapper {
          height: 280px;
        }
      }
      .add-modal-page {
        font-size: 0;
        .page-left {
          display: inline-block;
          width: 245px;
          text-align: left;
          vertical-align: top;
          .el-button {
            height: 24px;
            // margin-left: 4px !important;
          }
          .btn-one {
            margin-left: 0 !important;
          }
          .left-data {
            padding-left: 8px;
            color: #2e4057;
            font-size: 12px;
          }
        }
        .page-right {
          padding-top: 4px;
          display: inline-block;
          width: calc(100% - 245px);
          padding-right: 0;
        }
      }
    }
  }
  .el-dialog__footer {
    border-top: 1px solid #d4d4d7;
    padding: 16px;
    .member-modal-footer {
      font-size: 0;
      .el-button {
        margin-left: 8px !important;
      }
      .modal-footer-two {
        height: 28px;
      }
    }
  }
}
</style>
